import React from "react";
import { Link } from "react-router-dom";
import "swiper/css/autoplay";
// import Swiper core and required modules
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, {
  Autoplay,
  EffectFade,
  Navigation,
  Pagination,
} from "swiper";
SwiperCore.use([Navigation, Pagination, EffectFade, Autoplay]);
// install Swiper modules
function HeroArea() {
  const HeroSlider = {
    slidesPerView: 1,
    speed: 1500,
    spaceBetween: 0,
    loop: "true",
    clickable: true,
    autoplay: true,
    effect: "fade",
    centeredSlides: true,
    roundLengths: true,
    fadeEffect: {
      crossFade: true,
    },
  };
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      <section className="hero-area">
        <div className="swiper hero-slider">
          <Swiper
            pagination={{
              type: "bullets",
              clickable: true,
            }}
            {...HeroSlider}
            loop={true}
            className="swiper-wrapper"
          >
            <SwiperSlide className="swiper-slide">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className="hero-content-wrapper">
                      <div className="hero-content-wrap">
                        <div className="hero-content-img">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/images/hero-slider-1.jpg"
                            }
                            alt="images"
                          />
                        </div>
                        <div className="hero-content">
                          <h2>Creative</h2>
                          <h1>
                            Best solution for your <span>Business.</span>
                          </h1>
                          <p>
                             We provide smart and effective solutions to help your business grow. 
                            Our team focuses on delivering high-quality services tailored to your needs. 
                            Whether you're starting out or expanding, we ensure reliable support 
                            and innovative strategies to achieve your goals.
                          </p>
                          <Link
                            onClick={scrollTop}
                            to={`${process.env.PUBLIC_URL}/about`}
                            className="about-btn"
                          >
                            About us
                          </Link>
                          <Link
                            onClick={scrollTop}
                            to={`${process.env.PUBLIC_URL}/project`}
                            className="work-btn"
                          >
                            Our Work
                          </Link>
                          <div className="slider-num">
                            <span>01</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide className="swiper-slide">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className="hero-content-wrapper">
                      <div className="hero-content-wrap">
                        <div className="hero-content-img">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/images/hero-slider-2.png"
                            }
                            alt="images"
                          />
                        </div>
                        <div className="hero-content">
                          <h2>Creative</h2>
                          <h1>
                            The Best Solution for Your <span>Technology</span>
                          </h1>
                          <p>
                            We provide cutting-edge IT solutions to help your business stay ahead in a 
                            fast-changing digital world. From development to support, our services are 
                            designed to improve efficiency, security, and performance.
                          </p>
                          <Link
                            onClick={scrollTop}
                            to={`${process.env.PUBLIC_URL}/about`}
                            className="about-btn"
                          >
                            About us
                          </Link>
                          <Link
                            onClick={scrollTop}
                            to={`${process.env.PUBLIC_URL}/project`}
                            className="work-btn"
                          >
                            Our Work
                          </Link>
                          <div className="slider-num">
                            <span>02</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide className="swiper-slide">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className="hero-content-wrapper">
                      <div className="hero-content-wrap">
                        <div className="hero-content-img">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/images/hero-slider-3.png"
                            }
                            alt="images"
                          />
                        </div>
                        <div className="hero-content">
                          <h2>Creative</h2>
                          <h1>
                            Best solution for your <span>Markets.</span>
                          </h1>
                          <p>
                            We deliver strategic insights and data-driven solutions to help you navigate 
                            dynamic markets with confidence. Our approach empowers you to identify 
                            opportunities, reduce risks, and stay ahead of trends for sustainable growth.
                          </p>
                          <Link
                            onClick={scrollTop}
                            to={`${process.env.PUBLIC_URL}/about`}
                            className="about-btn"
                          >
                            About us
                          </Link>
                          <Link
                            onClick={scrollTop}
                            to={`${process.env.PUBLIC_URL}/project`}
                            className="work-btn"
                          >
                            Our Work
                          </Link>
                          <div className="slider-num">
                            <span>03</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
          <div className="swiper-pagination" />
        </div>
<div className="social-media">
  <ul className="social-list">
    <li>
      <a
        rel="noopener noreferrer"
         target="_blank"
        href="https://www.linkedin.com/company/gybits-private-limited/posts/?feedView=all"
      >
        LinkedIn
      </a>
    </li>
    <li>
      <a
        rel="noopener noreferrer"
        target="_blank"
        href="https://www.linkedin.com/company/gybits-private-limited/posts/?feedView=all"
      >
        LinkedIn
      </a>
    </li>
    <li>
      <a
        rel="noopener noreferrer"
        target="_blank"
        href="https://www.linkedin.com/company/gybits-private-limited/posts/?feedView=all"
      >
        LinkedIn
      </a>
    </li>
  </ul>
</div>
      </section>
    </>
  );
}

export default HeroArea;
